import * as moment from 'moment';
import {AssetModel} from '../_models/asset.model';
import {AssetsService} from './assets.service';
import {BehaviorSubject, forkJoin, Observable, of, Subject} from 'rxjs';
import {catchError, map, takeUntil} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {ErrorService} from '../../shared/_services/error.service';
import {HttpClient} from '@angular/common/http';
import {Injectable, OnDestroy} from '@angular/core';
import {PlantRiskCountryDataModel, PlantRiskCountryModel} from '../_models/plant-risk-country.model';
import {DateService} from './date.service';
import {SoService} from '../../shared/_services/so.service';
import {DATE_FORMAT, DateModel} from '../_models/date.model';

@Injectable({
  providedIn: 'root'
})
export class PlantRiskCountryService implements OnDestroy {

  private prc$ = new BehaviorSubject<PlantRiskCountryModel[]>([]);

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private assetsService: AssetsService,
    private dateService: DateService,
    private errorService: ErrorService,
    private httpClient: HttpClient,
    private soService: SoService,
  ) {
    this.getSo();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  // ********************************************************************************************************
  // LOAD DATA
  // ********************************************************************************************************

  private getSo(): void {
    this.soService.onNewSoActive()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (so) => {
          if (so === '') {
            this.callGetPlantRiskCountry();
          }
        }
      );
  }

  private callGetPlantRiskCountry(): void {
    const assets = this.assetsService.getAssets();
    const curDate = this.dateService.getNominationDate();
    if (assets?.length && curDate) {
      this.getPlantRiskCountryHttp(assets, curDate)
        .subscribe(
          (data) => {
            if (data?.length) {
              this.newPlantRiskCountry(data);
            }
          },
          (err) => {
            console.log(err);
            this.newPlantRiskCountry([]);
          }
        );
    }
  }

  private getPlantRiskCountryHttp(assets: AssetModel[], date: DateModel): Observable<any> {
    const httpRequests = [];
    for (const country of assets) {
      httpRequests.push(
        this.httpClient.get(
          environment.urlWarp + '/read/plantrisk-country/' + country.label +
          '?start=' + date.date +
          '&stop=' + date.date +
          '&start=' + moment(date.date).add(date.horAsOf, 'day').format(DATE_FORMAT) +
          '&stop=' + moment(date.date).add(date.horUpTo, 'day').format(DATE_FORMAT)
        ).pipe(
          map((r: any) => {
            return <PlantRiskCountryModel>{
              country: country.label,
              prcData: r.data ? r.data.map((d) => new PlantRiskCountryDataModel(d)) : []
            };
          }),
          catchError(this.errorService.handleError)
        )
      );
    }
    if (!httpRequests.length) {
      return of([]);
    }
    return forkJoin(httpRequests);
  }

  // ********************************************************************************************************
  // CHANGE DATA
  // ********************************************************************************************************

  // ********************************************************************************************************
  // BROADCAST DATA
  // ********************************************************************************************************

  private newPlantRiskCountry(data: PlantRiskCountryModel[]) {
    this.prc$.next(data);
  }

  onNewPlantRiskCountry(): Observable<PlantRiskCountryModel[]> {
    return this.prc$.asObservable();
  }

  getPlantRiskCountry(): PlantRiskCountryModel[] {
    return this.prc$.getValue();
  }

}
